import React from "react"

export default function Footer() {
  return <div className='bg-gray-600 text-gray-100 text-center text-xs'>
    <p>Copyright © Anno Ryoya All Rights Reserved.</p>
    <p>The illustrations on this site are provided by 'Loose Drawing'</p>
  </div>
}
